export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8944.e08474f4.jpg";